export const omitKeys = [
  'id',
  'assigneeId',
  'ownerType',
  'createdAt',
  'updatedAt',
  'ownerId',
];

const NAMESPACE = 'SERVICE_CATEGORY';
export const CLEAR_ITEMS = `${NAMESPACE}_CLEAR_ITEMS`;
export const FETCH_ITEMS = `${NAMESPACE}_FETCH_ITEMS`;
export const FETCH_ITEM = `${NAMESPACE}_FETCH_ITEM`;
export const UPDATE_ITEM = `${NAMESPACE}_UPDATE_ITEM`;
export const ADD_ITEM = `${NAMESPACE}_ADD_ITEM`;
export const DELETE_ITEM = `${NAMESPACE}_DELETE_ITEM`;

